
export const rolesNav = [
    {url: '/roles', label: 'Roles', key: 'roles.index', permissions: ['manage-roles']},
    {url: '/roles/[slug]', label: 'Roles', key: 'roles', parent_key: 'roles.index', permissions: ['manage-roles']},
    {url: '/roles/create', label: 'Roles create', key: 'roles.create', parent_key: 'roles.index', permissions: ['manage-roles']},
]